// This file can be removed once parent component app/views/admin/notaries/index.html.haml is migrated to react
import { BoardContent } from './BoardContent'
import './styles.modules.scss'

export default BoardContent
